/**
 * 应用 Store
 */

import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { ApplicationInfo, ApplicationListResponse } from '../types/application';
import { http } from '../services/request';

interface ApplicationState {
  // 状态
  applicationList: ApplicationInfo[];
  currentApplication: ApplicationInfo | null;
  total: number;
  loading: boolean;

  // Actions
  fetchApplicationList: (params?: { page?: number; pageSize?: number }) => Promise<void>;
  createApplication: (params: any) => Promise<void>;
  updateApplication: (id: string, params: any) => Promise<void>;
  deleteApplication: (id: string) => Promise<void>;
  setCurrentApplication: (app: ApplicationInfo | null) => void;
  clearApplicationList: () => void;
}

export const useApplicationStore = create<ApplicationState>()(
  devtools((set, get) => ({
    applicationList: [],
    currentApplication: null,
    total: 0,
    loading: false,

    fetchApplicationList: async (params = {}) => {
      set({ loading: true });
      try {
        // 模拟API调用
        // const response = await http.get<ApplicationListResponse>('/applications', params);
        // set({ applicationList: response.list, total: response.total, loading: false });

        // 模拟数据
        const mockData: ApplicationInfo[] = [
          {
            id: '1',
            name: '电商平台',
            description: '在线购物平台',
            type: 'web',
            status: 'active',
            createdAt: '2024-01-15'
          },
          {
            id: '2',
            name: '移动APP',
            description: '移动端应用',
            type: 'mobile',
            status: 'inactive',
            createdAt: '2024-02-20'
          },
          {
            id: '3',
            name: 'API服务',
            description: '后端API服务',
            type: 'api',
            status: 'pending',
            createdAt: '2024-03-10'
          },
        ];
        set({ applicationList: mockData, total: mockData.length, loading: false });
      } catch (error) {
        console.error('获取应用列表失败:', error);
        set({ loading: false });
        throw error;
      }
    },

    createApplication: async (params) => {
      try {
        // const response = await http.post('/applications', params);
        console.log('创建应用:', params);
        await get().fetchApplicationList();
      } catch (error) {
        console.error('创建应用失败:', error);
        throw error;
      }
    },

    updateApplication: async (id, params) => {
      try {
        // const response = await http.put(`/applications/${id}`, params);
        console.log('更新应用:', id, params);
        await get().fetchApplicationList();
      } catch (error) {
        console.error('更新应用失败:', error);
        throw error;
      }
    },

    deleteApplication: async (id) => {
      try {
        // const response = await http.delete(`/applications/${id}`);
        console.log('删除应用:', id);
        await get().fetchApplicationList();
      } catch (error) {
        console.error('删除应用失败:', error);
        throw error;
      }
    },

    setCurrentApplication: (app) => {
      set({ currentApplication: app });
    },

    clearApplicationList: () => {
      set({ applicationList: [], total: 0 });
    },
  }))
);
